export const INTEGRATION_TYPES = {
  webhook: {
    name: 'Webhook',
    canAutoTrigger: true,
    canUseAutomation: true,
    supportedTriggers: ['FormSubmitted', 'status_change'],
    // Global settings (organisatie-niveau)
    settingsSchema: {
      webhookUrl: { type: 'string', required: true, label: 'Webhook URL' },
    },
    // Form-specific settings (per formulier)
    formSettingsSchema: {
      customHeaders: {
        type: 'object',
        required: false,
        label: 'Custom Headers',
        default: {},
      },
      includeMetadata: {
        type: 'boolean',
        required: false,
        label: 'Include Form Metadata',
        default: true,
      },
    },
  },
  zapier: {
    name: 'Zapier',
    canAutoTrigger: true,
    canUseAutomation: true,
    supportedTriggers: ['FormSubmitted', 'status_change'],
    settingsSchema: {
      webhookUrl: { type: 'string', required: true, label: 'Webhook URL' },
    },
    formSettingsSchema: {
      customData: {
        type: 'object',
        required: false,
        label: 'Custom Data Fields',
        default: {},
      },
    },
  },
  google_tag_manager: {
    name: 'Google Tag Manager',
    canAutoTrigger: true,
    canUseAutomation: false,
    autoTrackEvents: ['FormView', 'FormPageView', 'FormSubmitted'],
    settingsSchema: {
      containerId: { type: 'string', required: true, label: 'Container ID' },
    },
    formSettingsSchema: {
      customEvents: {
        type: 'array',
        required: false,
        label: 'Custom Events to Track',
        default: [],
      },
      dataLayerVariables: {
        type: 'object',
        required: false,
        label: 'Custom DataLayer Variables',
        default: {},
      },
    },
  },
  facebook_pixel: {
    name: 'Meta Pixel (Facebook & Instagram)',
    canAutoTrigger: true,
    canUseAutomation: false,
    autoTrackEvents: ['FormView', 'FormPageView', 'FormSubmitted'],
    settingsSchema: {
      pixelId: { type: 'string', required: true, label: 'Pixel ID' },
    },
    formSettingsSchema: {
      customEvents: {
        type: 'array',
        required: false,
        label: 'Custom Events to Track',
        default: [],
      },
      eventParameters: {
        type: 'object',
        required: false,
        label: 'Custom Event Parameters',
        default: {},
      },
    },
  },
  linkedin_tag: {
    name: 'LinkedIn Insight Tag',
    canAutoTrigger: true,
    canUseAutomation: false,
    autoTrackEvents: ['FormView', 'FormPageView', 'FormSubmitted'],
    settingsSchema: {
      partnerId: { type: 'string', required: true, label: 'Partner ID' },
    },
    formSettingsSchema: {
      conversionId: {
        type: 'string',
        required: false,
        label: 'Conversion ID',
        default: '',
      },
    },
  },
  google_calendar: {
    name: 'Google Calendar',
    canAutoTrigger: false,
    canUseAutomation: false,
    settingsSchema: {
      connection: {
        type: 'oauth',
        required: true,
        label: 'Google Calendar Connection',
        provider: 'Google',
      },
      calendar_id: { type: 'string', required: true, label: 'Calendar ID' },
      expiry_date: { type: 'number', required: false, label: 'Expiry Date' },
      access_token: { type: 'string', required: false, label: 'Access Token' },
      calendar_name: { type: 'string', required: false, label: 'Calendar Name' },
      refresh_token: { type: 'string', required: false, label: 'Refresh Token' },
    },
    formSettingsSchema: {
      eventTitle: {
        type: 'string',
        required: false,
        label: 'Event Title Template',
        default: 'New appointment from {form.name}',
      },
      eventDescription: {
        type: 'string',
        required: false,
        label: 'Event Description Template',
        default: 'Submission from {form.name}',
      },
      duration: {
        type: 'number',
        required: false,
        label: 'Default Duration (minutes)',
        default: 60,
      },
    },
  },
  outlook_calendar: {
    name: 'Outlook Calendar',
    canAutoTrigger: false,
    canUseAutomation: false,
    settingsSchema: {
      connection: {
        type: 'oauth',
        required: true,
        label: 'Outlook Calendar Connection',
        provider: 'Outlook',
      },
      calendar_id: { type: 'string', required: false, label: 'Calendar ID' },
      calendar_name: { type: 'string', required: false, label: 'Calendar Name' },
      tenant_id: { type: 'string', required: false, label: 'Tenant ID' },
      expiry_date: { type: 'number', required: false, label: 'Expiry Date' },
      access_token: { type: 'string', required: false, label: 'Access Token' },
      refresh_token: { type: 'string', required: false, label: 'Refresh Token' },
    },
    formSettingsSchema: {
      eventTitle: {
        type: 'string',
        required: false,
        label: 'Event Title Template',
        default: 'New appointment from {form.name}',
      },
      eventDescription: {
        type: 'string',
        required: false,
        label: 'Event Description Template',
        default: 'Submission from {form.name}',
      },
      duration: {
        type: 'number',
        required: false,
        label: 'Default Duration (minutes)',
        default: 60,
      },
    },
  },
  plausible: {
    name: 'Plausible Analytics',
    canAutoTrigger: true,
    canUseAutomation: false,
    autoTrackEvents: ['FormView', 'FormPageView', 'FormSubmitted'],
    settingsSchema: {
      domain: { type: 'string', required: true, label: 'Plausible Domain (e.g. yourdomain.com)' },
    },
    formSettingsSchema: {
      customGoals: {
        type: 'array',
        required: false,
        label: 'Custom Goals to Track',
        default: [],
      },
    },
  },
  microsoft_clarity: {
    name: 'Microsoft Clarity',
    canAutoTrigger: false,
    canUseAutomation: false,
    settingsSchema: {
      projectId: {
        type: 'string',
        required: true,
        label: 'Clarity Project ID',
        description: 'Find this in your Clarity project settings at clarity.microsoft.com',
      },
    },
  },
  brevo: {
    name: 'Brevo',
    canAutoTrigger: true,
    canUseAutomation: false,
    supportedTriggers: ['FormSubmitted'],
    settingsSchema: {
      apiKey: { type: 'string', required: true, label: 'API Key' },
      defaultSender: {
        type: 'object',
        required: false,
        label: 'Default Sender',
        properties: {
          name: { type: 'string', required: true, label: 'Sender Name' },
          email: { type: 'string', required: true, label: 'Sender Email' },
        },
      },
    },
    formSettingsSchema: {
      listId: {
        type: 'string',
        required: true,
        label: 'Brevo List ID',
      },
      fieldMappings: {
        type: 'object',
        required: true,
        label: 'Field Mappings',
        properties: {
          email: { type: 'string', required: true, label: 'Email Field' },
          firstName: { type: 'string', required: false, label: 'First Name Field' },
          lastName: { type: 'string', required: false, label: 'Last Name Field' },
          phone: { type: 'string', required: false, label: 'Phone Field' },
          company: { type: 'string', required: false, label: 'Company Field' },
        },
        default: {},
        allowCustomFields: true,
      },
      customAttributes: {
        type: 'object',
        required: false,
        label: 'Custom Attributes',
        description: 'Key-value pairs for custom attributes (e.g. FORM_NAME: {form.name})',
        default: {
          FORM_NAME: '{form.name}',
          SUBMISSION_DATE: '{submission.date}',
        },
      },
      doubleOptIn: {
        type: 'boolean',
        required: false,
        label: 'Enable Double Opt-in',
        default: false,
      },
      templateId: {
        type: 'number',
        required: false,
        label: 'Welcome Email Template ID',
        description: 'Brevo template ID for welcome email (optional)',
      },
    },
  },
  loops: {
    name: 'Loops',
    canAutoTrigger: false,
    canUseAutomation: true,
    supportedTriggers: ['FormSubmitted', 'status_change', 'deal_status_change'],
    settingsSchema: {
      apiKey: {
        type: 'string',
        required: true,
        label: 'API Key',
        description: 'Je Loops API key (Settings → API in je Loops account).',
      },
    },
  },
  zo_boekhouden: {
    name: 'ZO Boekhouden',
    canAutoTrigger: false,
    canUseAutomation: false,
    settingsSchema: {
      webhookUrl: {
        type: 'string',
        required: true,
        label: 'Webhook-URL',
        description:
          'Endpoint van ZO waarop wij events sturen (invoice.updated, payment.received).',
      },
      webhookSecret: {
        type: 'string',
        required: false,
        label: 'Webhook-secret',
        description: 'Gedeeld geheim voor HMAC-handtekening. Deel dit veilig met ZO.',
      },
    },
  },
  snelstart: {
    name: 'SnelStart',
    canAutoTrigger: false,
    canUseAutomation: false,
    settingsSchema: {
      connection_key: {
        type: 'string',
        required: true,
        label: 'Maatwerksleutel',
        description: 'Sleutel uit SnelStart Web → Koppelingen → Maatwerk.',
      },
    },
  },
  twinfield: {
    name: 'Twinfield',
    canAutoTrigger: false,
    canUseAutomation: false,
    settingsSchema: {},
  },
  moneybird: {
    name: 'Moneybird',
    canAutoTrigger: false,
    canUseAutomation: false,
    settingsSchema: {
      api_token: {
        type: 'string',
        required: true,
        label: 'API-token',
        description:
          'Persoonlijke API-token uit Moneybird (Mijn account → Ontwikkelaars → API-tokens).',
      },
    },
  },
  activecampaign: {
    name: 'ActiveCampaign',
    canAutoTrigger: true,
    canUseAutomation: true,
    supportedTriggers: ['FormSubmitted', 'status_change', 'deal_status_change'],
    settingsSchema: {
      apiUrl: {
        type: 'string',
        required: true,
        label: 'API URL',
        description: 'Your ActiveCampaign API URL (e.g. https://youraccount.api-us1.com)',
      },
      apiKey: { type: 'string', required: true, label: 'API Key' },
    },
    formSettingsSchema: {
      enabled: {
        type: 'boolean',
        required: true,
        label: 'Ingeschakeld',
        default: true,
      },
      fieldMappings: {
        type: 'object',
        required: true,
        label: 'Field Mappings',
        properties: {
          email: { type: 'string', required: true, label: 'Email Field' },
          firstName: { type: 'string', required: false, label: 'First Name Field' },
          lastName: { type: 'string', required: false, label: 'Last Name Field' },
          phone: { type: 'string', required: false, label: 'Phone Field' },
          company: { type: 'string', required: false, label: 'Company Field' },
        },
        default: {},
        allowCustomFields: true,
      },
      customFieldMappings: {
        type: 'array',
        required: false,
        label: 'Custom Field Mappings',
        description: 'Map form fields to ActiveCampaign custom contact fields',
        default: [],
        itemSchema: { formField: 'string', acFieldId: 'string' },
      },
      tag: {
        type: 'string',
        required: false,
        label: 'Tag',
        description: 'Tag name to add on submission (triggers AC automation)',
        default: '',
      },
      deal: {
        type: 'object',
        required: false,
        label: 'Deal',
        default: {
          enabled: false,
          title: '{{email}} - Form Submission',
          pipelineId: '',
          stageId: '',
          valueField: '',
          currency: 'eur',
        },
        properties: {
          enabled: { type: 'boolean', label: 'Create deal on submission' },
          title: { type: 'string', label: 'Deal title' },
          pipelineId: { type: 'string', label: 'Pipeline ID' },
          stageId: { type: 'string', label: 'Stage ID' },
          valueField: { type: 'string', label: 'Form field for deal value' },
          currency: { type: 'string', label: 'Currency code' },
        },
      },
      dealFieldMappings: {
        type: 'array',
        required: false,
        label: 'Deal Field Mappings',
        description: 'Map form fields to ActiveCampaign deal custom fields',
        default: [],
        itemSchema: { formField: 'string', acDealFieldId: 'string' },
      },
    },
  },
};
